import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPasswordConfirm from './pages/ResetPasswordConfirm';
import PublicKiosk from './pages/PublicKiosk';
import PublicEquipment from './pages/PublicEquipment';
import PublicIncident from './pages/PublicIncident';
function App() {
  // Simple check to protect the dashboard
  const isAuthenticated = () => !!localStorage.getItem('access_token');

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/kiosk/:siteId" element={<PublicKiosk />} />
        <Route 
          path="/dashboard" 
          element={isAuthenticated() ? <Dashboard /> : <Navigate to="/" />} 
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPasswordConfirm />} />
        <Route path="/equipment/:uuid" element={<PublicEquipment />} />
        <Route path="/report-incident/:uuid" element={<PublicIncident />} />
      </Routes>
    </Router>
  );
}

export default App;